function getCookie(name) {
    const cookies = document.cookie.split('; ');
    for (let i = 0; i < cookies.length; i++) {
      const [key, value] = cookies[i].split('=');
      if (key === name) return value;
    }
    return null;
  }
  
  function replaceParam(url) {
    if (!url) return url;
  
    let qparam = window.location.search;
    const cookies = ['_conv_v', '_conv_s'];
    const cookieParams = cookies
      .map(cookie => getCookie(cookie))
      .filter(Boolean)
      .map((value, index) => `${cookies[index]}=${value}`)
      .join('&');
  
    if (cookieParams) {
      qparam += (qparam ? "&" : "?") + cookieParams;
    }
  
    if (url.includes('#params')) {
      return url.replace('#params', qparam);
    } else {
      return url;
    }
  }
  
  // Make globally accessible
  window.replaceParam = replaceParam;
  
  // Auto-update links
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("a").forEach(el => {
      const href = el.getAttribute("href");
      if (href) el.setAttribute("href", replaceParam(href));
    });
  });